import { StringUtilities } from './String.utility';

const getMock: () => Partial<StringUtilities> = () => {
    const mock: Partial<StringUtilities> = {
        formatString: (stringToFormat: string) => stringToFormat,
        isAnEmailString: (email: string) => true,
        stripStart: (rawString: string, prefixToKill: string) => 'stripped',
        isUrlString: (urlString: string) => true,
        parseEmailFirstNameLastNameFromString: (inputString: string) => ({
            email: 'test@test.com',
            firstName: 'John',
            lastName: 'Wick'
        }),
        displayName: (
            firstName: string,
            lastName: string,
            middleName: string
        ) => firstName + ' ' + middleName + ' ' + lastName,
        replaceFNameToken: (content: string, firstName: string) =>
            'Replaced first name',
        uncapitalize: (capitalizedString: string) => 'UncapitalizedString'
    };
    return mock;
};

export const stringUtilitiesMock = {
    getMock,
    provider: (Service: typeof StringUtilities) => ({
        provide: Service,
        useValue: getMock()
    })
};
